export function LoadLocalStorage(name) {
    return localStorage.getItem(name);
  }